export default __webpack_public_path__ + "static/media/border-rounded-linea2.495b4b2f.svg";